import React from "react";
import logo from '../../Assests/logo.jpg';
const AnimatedLoader = () => {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        zIndex: 9999,
      }}
    >
      <img
        src={logo} // Place your animated image in public folder
        alt="Loading..."
        style={{ width: "100px", height: "100px", animation: "pulse 1.5s infinite" }}
      />
    </div>
  );
};

export default AnimatedLoader;
